import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SpinnerRef } from '../../common/components/spinner/overlay-ref.service';
import { TranslationService } from '../../common/services/languages/translation.service';
import { NgRedux, select } from '@angular-redux/store';
import { AppState } from '../../store/state.model';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { ApiHandlerService } from '../services/api-handler/api-handler.service';
import { FileDispatcher } from '../../store/file/file-dispatcher';
import { Observable } from 'rxjs';
import { File } from '../../store/file/file-state.model';
import { AuthDispatcher } from '../../store/auth/auth-dispatcher';
import { MatFormField, MatLabel, MatSelect, MatOption } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-generation',
    templateUrl: './generation.component.html',
    styleUrls: ['./generation.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, NgFor, MatOption, TranslatePipe]
})
export class GenerationComponent implements OnInit {
  /**
   *@arg prefGenrationFlag selected generation value to be emitted
   **/
  @Output() prefGenrationFlag: EventEmitter<string> = new EventEmitter<string>();
  /**
  *@arg selectedGeneration to set the selected language
  **/
  public selectedGeneration: string;
  /**
  *@arg asiSelectedGeneration to set the selected language
  **/
  public asiSelectedGeneration: string;
  /**
*@arg packageSelectedGeneration to set the selected language
**/
  public packageSelectedGeneration: string;
  /**
  *@arg selectorProperty to set store the generations which are received from the api
  **/
  public selectorProperty: any;
  /**
  *@arg componentType returns true if package otherwise false
  **/
  @Input() componentType: string;
  /**
  *@arg Declaration of spinner Ref
  **/
  public spinnerRef: SpinnerRef;
  /**
  *@arg fileObservable to observe file observable
  **/
  @select('file') readonly fileObservable: Observable<File>;
  generationVariable: string;
  constructor(public translate: TranslationService,
    public apiHandler: ApiHandlerService,
    public router: Router,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    public authDispatcher: AuthDispatcher,
    public ngRedux: NgRedux<AppState>,
    public fileDispatcher: FileDispatcher) { }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.fileObservable.subscribe((fileStore) => {
      if (!this.selectorProperty && fileStore.supportedGenerations.length > 0) {
        this.selectorProperty = this.componentType === 'product' ?
          fileStore.supportedGenerations.filter(generation => generation !== '21MM') : fileStore.supportedGenerations;
      }
      this.selectedGeneration = !!this.componentType ? fileStore[this.generationVariable] : '';
    });
  }
  /**
   *@method changeGeneration Set the generation when selected
   **/
  public changeGeneration(value: string): void {
    this.fileDispatcher.setGeneration(value);
    switch (this.componentType) {
      case 'package':
        this.fileDispatcher.setPackageGeneration(value);
        this.generationVariable = 'packageGeneration';
        break;
      case 'asi':
        this.fileDispatcher.setAsiGeneration(value);
        this.generationVariable = 'asiGeneration';
        break;
      case 'product':
        this.fileDispatcher.setProductGeneration(value);
        this.generationVariable = 'productGeneration';
        break;
      case 'asi-product':
        this.fileDispatcher.setAsiProductMapGeneration(value);
        this.generationVariable = 'asiproductGeneration';
        break;
    }
    this.prefGenrationFlag.emit(value);
  }
}
